import { useQuery } from '@apollo/client'
import { useActiveChannelSnapshot } from '@chain-zen/chat'
import { useIsMobile } from '@chain-zen/ui'

import { InboxShipmentHeader } from '../../../app/(protected)/_components/shipment/inbox-shipment-header'
import { ShipmentOverviewSections } from '../../../app/(protected)/_components/shipment/overview-sections'
import { ShipmentProvider } from '../../../contexts/shipment-context'
import { MY_SHIPMENT } from '../../../data/queries/shipment'
import type { IShipment } from '../../../types/shipment'

/**
 * Displays the details of a shipment chat
 */
export const ShipmentChatDetails = ({ closeChatDetails }: { closeChatDetails?: () => void }) => {
  const isMobile = useIsMobile()
  const { channelID } = useActiveChannelSnapshot()
  const queryID = channelID?.split('SHIPMENT-')[1] || ''

  const { data } = useQuery(MY_SHIPMENT, {
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-only',
    variables: { id: queryID }
  })

  const shipmentDetails: IShipment = data?.myShipment || null
  const isShipmentOwner = shipmentDetails?.isShipmentOwner || false

  if (!shipmentDetails) return null

  return (
    <ShipmentProvider
      isShipmentOwner={isShipmentOwner}
      shipmentID={shipmentDetails?.id || ''}
      shipmentNumber={shipmentDetails?.shipmentNumber || ''}
    >
      <div className="flex h-full min-h-0 flex-col">
        <InboxShipmentHeader
          shipmentID={shipmentDetails?.id || ''}
          shipment={shipmentDetails}
          isShipmentOwner={shipmentDetails?.isShipmentOwner}
          onBack={isMobile ? closeChatDetails : undefined}
        />
        <div className="min-h-0 flex-1 overflow-y-auto p-4">
          <ShipmentOverviewSections shipment={shipmentDetails} backhaulPostsView="card" />
        </div>
      </div>
    </ShipmentProvider>
  )
}
